import { render, staticRenderFns } from "./TMenuNavGroup.vue?vue&type=template&id=3be14168&scoped=true&"
import script from "./TMenuNavGroup.vue?vue&type=script&lang=js&"
export * from "./TMenuNavGroup.vue?vue&type=script&lang=js&"
import style0 from "./TMenuNavGroup.vue?vue&type=style&index=0&id=3be14168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be14168",
  null
  
)

export default component.exports